import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "itemlist-toast",
  autofocus: false
}
const _hoisted_2 = { class: "itemlist-toast itemlist-toast-multiple-item-width'" }
const _hoisted_3 = { class: "itemlist-toast-text" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = ["src"]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = ["src"]
const _hoisted_8 = ["disabled"]
const _hoisted_9 = ["src"]

import { watch, ref, computed, onMounted, onUnmounted } from "vue";
import { useToast } from "primevue/usetoast";
import IconButton from "../IconButton.vue";
import { SessionWithOrdersAndType } from "../../types/session-interfaces";
import { FolderWithSessions } from "../../types/folder-interfaces";
import { useStore } from "vuex";


export default /*@__PURE__*/_defineComponent({
  __name: 'RowActionMenubar',
  props: {
    toggleSessionMenu: { type: Function },
    visible: { type: Boolean }
  },
  emits: ["renameItem", "moveItem"],
  setup(__props: any, { emit: __emit }) {

const ThreeDotsWhiteIcon =
  require("../../assets/images/ThreeDotsWhiteIcon.svg") as string;
const CheckboxSemiIcon =
  require("../../assets/images/CheckmarkInputSemi.svg") as string;
const MoveIcon = require("../../assets/images/SmallDarkMove.svg") as string;
const ArchiveIcon =
  require("../../assets/images/SmallDarkArchive.svg") as string;
const RenameIcon = require("../../assets/images/SmallDarkRename.svg") as string;

const props = __props;

const emit = __emit;

const toast = useToast(), 
      store = useStore(),
      hasMixedTypes = ref<boolean>(false),
      multipleItemsSelected = ref<boolean>(false),
      itemType = ref<string>(),
      renameButton = ref<HTMLButtonElement | null>(null),
      archiveButton = ref<HTMLButtonElement | null>(null),
      moveButton = ref<HTMLButtonElement | null>(null);

const selection = computed({
        get: () =>  store.getters['itemList/getSelectedItems'],
        set: (val) => store.dispatch('itemList/updateSelection', val),
      });

watch(selection, ( newValue ) => {
  const firstType = newValue[0]?.type;
  itemType.value = firstType;
  
  if (newValue && newValue.length === 0) {
      multipleItemsSelected.value = false;
    } else if (newValue && newValue.length > 1) {
      multipleItemsSelected.value = true;

        // Check if all items have the same type
      hasMixedTypes.value = newValue.some((item: SessionWithOrdersAndType | FolderWithSessions ) => item.type !== firstType);

        if (hasMixedTypes.value) {
          setTimeout(() => {
            toast.add({
              group: "notification",
              summary: "You can’t select both folders and sessions.",
              life: 3000,
            });
          }, 20);
        }
    }
    else {
      multipleItemsSelected.value = false;
      hasMixedTypes.value = false;
  }
});

watch(() => props.visible, (newValue) => {
  if (newValue === true) {
    setTimeout(() => {
          toast.add({
            detail: selection,
            group: "rowactionmenubar",
          });
        }, 20);
  } else {
    toast.removeGroup("rowactionmenubar");
  }
})

function renameItem() {
  emit("renameItem");
}

async function archiveItem() {
  const plural = selection.value.length > 1;
  await Promise.all(
  selection.value.map((item: 
  SessionWithOrdersAndType | FolderWithSessions) =>
    store.dispatch('itemList/archiveItem', item.id)
  ));
  await store.dispatch('itemList/clearSelection');

  toast.add({
    severity: "secondary",
    summary: `Item${plural ? 's' : ''} archived successfully.`,
    life: 3000,
    group: "notification",
  });
}

function moveItem() {
  emit("moveItem");
}

function deselectAllItems() {
  store.commit("itemList/clearSelection");
}

function handleKeyDown(event: KeyboardEvent) {
  switch (event.key) {
    case "r":
      renameButton.value?.focus();
      break;
    case "a":
      archiveButton.value?.focus();
      break;
    case "m":
      moveButton.value?.focus();
      break;
    case "Escape":
      // eslint-disable-next-line no-case-declarations
      const activeElement = document.activeElement as HTMLElement;
      if (activeElement) {
        activeElement.blur();
      }
      break;
  }
}

onMounted(() => {
  window.addEventListener("keydown", handleKeyDown)
})

onUnmounted(() => {
  window.removeEventListener("keydown", handleKeyDown)
})

return (_ctx: any,_cache: any) => {
  const _component_Toast = _resolveComponent("Toast")!
  const _directive_tooltip = _resolveDirective("tooltip")!
  const _directive_focustrap = _resolveDirective("focustrap")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Toast, {
      position: "bottom-center",
      class: "itemlist-toast-wrapper",
      style: { bottom: '4.8rem', left: '51.5%' },
      group: "rowactionmenubar",
      pt: {
      closeButton: {
          autofocus: false,
          class: 'itemlist-toast-close-button',
          style: {
            width: '2.4rem',
            height: '2.4rem',
            color: '#ffffff',
          },
      }
    }
    }, {
      message: _withCtx(() => [
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _withDirectives(_createVNode(IconButton, {
              tabindex: "0",
              icon: _unref(CheckboxSemiIcon),
              alt: 'Deselect',
              xsmall: "",
              onClick: deselectAllItems,
              "aria-haspopup": "true",
              "aria-controls": "menus",
              ariaLabel: "Deselect all items",
              enterPress: () => deselectAllItems,
              class: "itemlist-toast-deselect"
            }, null, 8, ["icon", "enterPress"]), [
              [
                _directive_tooltip,
                'Deselect',
                void 0,
                { top: true }
              ]
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("strong", null, _toDisplayString(selection.value.length) + " selected", 1)
            ]),
            _cache[7] || (_cache[7] = _createElementVNode("div", {
              "aria-hidden": "true",
              class: "itemlist-toast-separator"
            }, null, -1)),
            (!multipleItemsSelected.value)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  ref_key: "renameButton",
                  ref: renameButton,
                  onClick: renameItem,
                  onKeydown: _cache[0] || (_cache[0] = ($event) => {
            if ($event.key === 'Enter') {
              $event.preventDefault();
              renameItem();
            }
          }),
                  class: "itemlist-toast-button itemlist-toast-button-first",
                  disabled: multipleItemsSelected.value,
                  "aria-label": "Rename"
                }, [
                  _createElementVNode("img", {
                    role: "presentation",
                    src: _unref(RenameIcon),
                    alt: "RenameIcon"
                  }, null, 8, _hoisted_5),
                  _cache[4] || (_cache[4] = _createTextVNode(" Rename "))
                ], 40, _hoisted_4))
              : _createCommentVNode("", true),
            (itemType.value !== 'folder')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  ref_key: "moveButton",
                  ref: moveButton,
                  onClick: moveItem,
                  onKeydown: _cache[1] || (_cache[1] = ($event) => {
            if ($event.key === 'Enter') {
              $event.preventDefault();
              moveItem();
            }
          }),
                  class: _normalizeClass(["itemlist-toast-button", 
            selection.value.length !== 1 ? 'itemlist-toast-button-first' : ''
          ]),
                  disabled: hasMixedTypes.value,
                  "aria-label": "Move"
                }, [
                  _createElementVNode("img", {
                    src: _unref(MoveIcon),
                    alt: "MoveIcon"
                  }, null, 8, _hoisted_7),
                  _cache[5] || (_cache[5] = _createTextVNode(" Move "))
                ], 42, _hoisted_6))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              ref_key: "archiveButton",
              ref: archiveButton,
              onClick: archiveItem,
              onKeydown: _cache[2] || (_cache[2] = ($event) => {
            if ($event.key === 'Enter') {
              $event.preventDefault();
              archiveItem();
            }
          }),
              class: _normalizeClass(["itemlist-toast-button", 
            selection.value.length === 1 ? 'itemlist-toast-button-last' : ''
          ]),
              disabled: hasMixedTypes.value,
              "aria-label": "Archive"
            }, [
              _createElementVNode("img", {
                src: _unref(ArchiveIcon),
                alt: "ArchiveIcon"
              }, null, 8, _hoisted_9),
              _cache[6] || (_cache[6] = _createTextVNode(" Archive "))
            ], 42, _hoisted_8),
            (selection.value.length === 1)
              ? _withDirectives((_openBlock(), _createBlock(IconButton, {
                  key: 2,
                  class: "itemlist-toast-deselect itemlist-toast-left-seperate",
                  icon: _unref(ThreeDotsWhiteIcon),
                  alt: 'Settings',
                  xsmall: "",
                  onClick: _cache[3] || (_cache[3] = (e) => props.toggleSessionMenu(e, selection.value[0])),
                  ariaLabel: "Open session menu",
                  enterPress: (e) => props.toggleSessionMenu(e, selection.value[0]),
                  "aria-haspopup": "true",
                  "aria-controls": "menus"
                }, null, 8, ["icon", "enterPress"])), [
                  [
                    _directive_tooltip,
                    'Settings',
                    void 0,
                    { top: true }
                  ]
                ])
              : _createCommentVNode("", true)
          ])
        ])), [
          [_directive_focustrap]
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_Toast, {
      position: "top-center",
      group: "notification",
      class: "itemlist-notification-toast-wrapper"
    })
  ], 64))
}
}

})